import { render } from "./Home.vue?vue&type=template&id=ed21ae0e&bindings={\"eDevletLoginUrl\":\"data\",\"showEdevletLogin\":\"data\",\"cards\":\"data\",\"startPayload\":\"data\",\"start\":\"options\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script